import * as React from "react";
import { useState, useCallback, useEffect } from "react";
import { ConfirmCancelDialog } from "../controls";
import { registerConfirmHandler } from "../services/confirmService";
import { useRootStore } from "../../store/contexts";

type ConfirmState = {
  open: boolean;
  title: string;
  description: string;
  resolve: ((value: boolean) => void) | null;
};

export const ConfirmDialogProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const rootStore = useRootStore();
  const { langStore } = rootStore;

  const [state, setState] = useState<ConfirmState>({
    open: false,
    title: "",
    description: "",
    resolve: null,
  });

  const handleConfirm = useCallback(
    (title: string, description: string): Promise<boolean> => {
      return new Promise((resolve) => {
        setState({
          open: true,
          title,
          description,
          resolve,
        });
      });
    },
    []
  );

  useEffect(() => {
    registerConfirmHandler(handleConfirm);
  }, [handleConfirm]);

  const handleYes = useCallback(() => {
    state.resolve?.(true);
    setState((s) => ({ ...s, open: false, resolve: null }));
  }, [state]);

  const handleNo = useCallback(() => {
    state.resolve?.(false);
    setState((s) => ({ ...s, open: false, resolve: null }));
  }, [state]);

  return (
    <>
      {children}
      <ConfirmCancelDialog
        open={state.open}
        title={state.title}
        description={state.description}
        onConfirm={handleYes}
        onCancel={handleNo}
        confirmLabel={langStore.addCommand}
      />
    </>
  );
};
